import { type GridFeatureMode } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';

export const useDataGridMode = (
  mode: 'client' | 'server'
): {
  paginationMode: GridFeatureMode;
  sortingMode: GridFeatureMode;
  filterMode: GridFeatureMode;
} => {
  return useMemo(
    () => ({
      paginationMode: mode === 'server' ? 'server' : 'client',
      sortingMode: mode === 'server' ? 'server' : 'client',
      filterMode: mode === 'server' ? 'server' : 'client',
    }),
    [mode]
  );
};
